let title = ' | Gestor - Comercial Ivaiporã'

const gpp = {
    path: '/gpp',
    props: true,
    component: () => import('@/Components/GPP/GPPContainer'),
    children: [
        {
            path: '',
            name: 'GPPDashboard',
            component: () => import('@/Components/GPP/GPPDashboard'),
            meta: {
                title: 'GPP' + title,
                permission: 'gpp_dashboard',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Power BI',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/gpp',
                    }
                ]
            }
        },
    ]
}

export default gpp